// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU7_thecomp__0GQOt","swiperTool":"EU7_swiperTool__AqLBh"};